module.exports = __webpack_public_path__ + "static/media/averta-bold.b2fed317.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-bold.woff
// module id = 844
// module chunks = 4